<div class="bg-white px-6 py-32 lg:px-8">
  <div class="mx-auto max-w-3xl text-base/7 text-gray-700">
    <h1 class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Privacy Policy</h1>
    <p class="text-base/7 font-semibold text-indigo-600">Effective January 1, 2026</p>
    <div class="mt-10 max-w-2xl text-gray-600">
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">1. Information We Collect</h2>
        <p class="mt-3">Crown Wash may collect:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Service address</li>
            <li>Property photos</li>
            <li>Browser/device information</li>
            <li>IP address</li>
            <li>Communication history</li>
        </ul>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">2. How We Use Information</h2>
        <p class="mt-3">We may use collected information to:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Provide quotes</li>
            <li>Schedule services</li>
            <li>Process payments</li>
            <li>Communicate with customers</li>
            <li>Improve services</li>
            <li>Operate our business</li>
        </ul>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">3. Digital and Electronic Communications</h2>
        <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">3.1 Email Communications</h3>
        <p class="mt-3">By providing your email address and agreeing to the Terms of Service and Privacy Policy, you consent to receive:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Emails</li>
        </ul>
        <p class="mt-3">These emails may include:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Quotes</li>
            <li>Appointment confirmations</li>
            <li>Appointment reminders</li>
            <li>Arrival updates</li>
            <li>Service updates</li>
            <li>Billing notifications</li>
            <li>Customer support messages</li>
        </ul>
        <p class="mt-3">You may opt-out at any time by clicking the unsubscribe link in our emails or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
        <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">3.2 SMS/MMS Communications</h3>
        <p class="mt-3">
            Providing a mobile telephone number, selecting text messaging as a preferred contact method, submitting a contact or quote request, or accepting the Terms of Service and Privacy Policy does not, by itself, constitute consent to receive recurring SMS or MMS messages. 
            Crown Wash sends recurring SMS or MMS messages only when you separately and affirmatively opt in through an optional, initially unselected SMS consent control that requires a separate affirmative selection on our website or through another opt-in process that clearly discloses the specific text messages you are agreeing to receive.
            Consent to receive text messages is optional and is not a condition of purchasing or receiving any property, goods, or services from Crown Wash.
        </p>
        <p class="mt-3">When you opt in, Crown Wash may collect and maintain:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Your mobile telephone number</li>
            <li>Your SMS consent status</li>
            <li>The date and time consent was provided</li>
            <li>The webpage, form, or other source through which consent was provided</li>
            <li>The consent language presented when you opted in</li>
            <li>Your messaging preferences</li>
            <li>History of text messages conversations between you and Crown Wash</li>
            <li>Opt-out and help requests</li>
        </ul>
        <p class="mt-3">
            SMS/MMS Communications consent detailed in this section applies to non-marketing, customer care related messages.
            Any marketing or promotional messages sent by Crown Wash will be subject to separate consent and opt-in requirements, and will not be sent without your prior consent.
        </p>
        <p class="mt-3">If you separately and affirmatively opt-in to SMS communications, you consent to receive:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>SMS/MMS messages</li>
        </ul>
        <p class="mt-3">Related to:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Quotes</li>
            <li>Appointment confirmations</li>
            <li>Appointment reminders</li>
            <li>Arrival updates</li>
            <li>Service updates</li>
            <li>Billing notifications</li>
            <li>Payment confirmations</li>
            <li>Customer support messages</li>
            <li>Post service appointment follow-ups</li>
        </ul>
        <p class="mt-3">Message and data rates may apply. You may opt-out at any time by replying “STOP” or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
        <p class="mt-3">You may also request help by replying “HELP” or contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
        <p class="mt-3">Message frequency varies based on your quote requests, appointments, services, customer-initiated communications, and account activity.</p>
        <h3 class="mt-5 text-pretty text-2xl font-semibold tracking-tight text-gray-900">3.3 Voice Communications</h3>
        <p class="mt-3">By providing your phone number and agreeing to the Terms of Service and Privacy Policy, you consent to receive:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Voice calls</li>
            <li>Voicemail</li>
        </ul>
        <p class="mt-3">Related to:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Contact Request Form follow-ups</li>
            <li>Quotes</li>
            <li>Appointment confirmations</li>
            <li>Appointment reminders</li>
            <li>Arrival updates</li>
            <li>Service updates</li>
            <li>Billing notifications</li>
            <li>Customer support messages</li>
        </ul>
        <p class="mt-3">Message and data rates may apply. You may opt-out at any time by contacting us directly via call or text at <a href="tel:+17042189659">(704) 218-9659</a> or email <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">4. Cookies & Analytics</h2>
        <p class="mt-3">Our website may use:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Cookies</li>
            <li>Analytics tools</li>
            <li>Meta Pixel</li>
            <li>Google Analytics</li>
            <li>Similar technologies</li>
        </ul>
        <p class="mt-3">These tools help us improve website functionality, marketing performance, and user experience.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">5. Sharing of Information</h2>
        <p class="mt-3">Crown Wash does not sell personal information.</p>
        <p class="mt-3">Crown Wash may disclose personal information to service providers that assist with business operations, including:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Payment processing</li>
            <li>Appointment scheduling</li>
            <li>Customer relationship management</li>
            <li>Website hosting</li>
            <li>Analytics</li>
            <li>Communications and text message delivery</li>
            <li>Accounting, insurance, and legal compliance</li>
        </ul>
        <p class="mt-3">
            These providers may process personal information only as reasonably necessary to provide services to Crown Wash or as required by law.
            No mobile information, including mobile telephone numbers, SMS opt-in information, or SMS consent records, will be shared with third parties or affiliates for marketing or promotional purposes.
            Crown Wash may provide mobile information to telecommunications carriers, messaging platforms, and other service providers solely as necessary to transmit and administer Crown Wash text messages. 
            These providers are not authorized to use that information for their own marketing or promotional purposes.
            SMS opt-in data and consent will not be sold, rented, or transferred to third parties for their own marketing purposes.
        </p>
        <p class="mt-3">Notwithstanding any other provision of this Privacy Policy, text messaging originator opt-in data and consent will not be sold, rented, transferred, or shared with third parties or affiliates for their marketing or promotional purposes.</p>
        <p class="mt-3">Crown Wash may disclose personal information if required by law or in response to valid legal requests, such as subpoenas or court orders.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">6. Data Security</h2>
        <p class="mt-3">We use commercially reasonable safeguards to protect customer information. However, no internet transmission or storage system is completely secure.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">7. Data Retention</h2>
        <p class="mt-3">Information may be retained for:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Operational purposes</li>
            <li>Legal purposes</li>
            <li>Tax purposes</li>
            <li>Insurance purposes</li>
            <li>Business purposes</li>
        </ul>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">8. User Rights</h2>
        <p class="mt-3">Customers may request to:</p>
        <ul class="mt-2 list-disc list-inside">
            <li>Access their personal information</li>
            <li>Update their personal information</li>
            <li>Delete their personal information</li>
        </ul>
        <p class="mt-3">by contacting Crown Wash directly.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">9. Children's Privacy</h2>
        <p class="mt-3">Our services are not directed toward children under 13 years old.</p>
        <p class="mt-3">We do not knowingly collect personal information from children.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">10. Third-Party Links</h2>
        <p class="mt-3">Our website may contain links to third-party websites.</p>
        <p class="mt-3">Crown Wash is not responsible for the privacy practices or content of external websites.</p>
        <h2 class="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">11. Changes to Privacy Policy</h2>
        <p class="mt-3">We reserve the right to update this Privacy Policy at any time.</p>
        <p class="mt-3">Updated versions will be posted to the website.</p>
    </div>
  </div>
</div>
